import React, { useEffect, useState } from 'react'
import styles from "../../../pages/DashBoard/ExternalDash/Issuer/ChangeRequest.module.css"
import API from '.././../../ApiConfig'
import { ACCEPT_DISCREPANCY_TICKET_BY_ISSUER, DOCUMENT_PREVIEW, REISSUE_NEW_DOCUMENT_TICKET_ID } from '../../../Utils/constant';
import cogoToast from 'cogo-toast-react-17-fix';
import { MESSAGE } from '../../../Utils/Strings';
import Loader from '../../Loader';
import { useNavigate } from 'react-router-dom';

export default function PreviewModal({ data, original, onClose }) {
    const [Loading, setloading] = useState(false);
    const [preview, setPreview] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
        setloading(true)
        API.post(ACCEPT_DISCREPANCY_TICKET_BY_ISSUER + original.discrepancy_ticket_id, data.accept_doc_fields)
            .then(response => {
                setPreview(response.data.data.pdf)
            }).catch((err) => {
                console.error(err)
            })
            .finally(() => setloading(false))
    }, [])

    // useEffect(() => {
    //     if (pdfId) {
    //         API.get(DOCUMENT_PREVIEW + pdfId, { responseType: 'blob' })
    //             .then(response => { setPreview(window.URL.createObjectURL(response.data)) })
    //             .catch(err => { setPreview(null) })
    //     }
    // }, [pdfId])

    const reIssue = () => {
        setloading(true)
        API.post(REISSUE_NEW_DOCUMENT_TICKET_ID + original.discrepancy_ticket_id, {
            comment: data.comment,
            accept_doc_fields: data.accept_doc_fields
        }).then(res => {
            navigate('/dashboard/credentials')
            cogoToast.success("Ticket Resolved Successfully")
        }).catch(err => {
            // console.log(err)
            onClose(false)
            if (err?.response)
                cogoToast.error(err.response.data.message)
            else
                cogoToast.error(MESSAGE.DEFAULT_ERROR_MESSAGE)
        })
            .finally(() => setloading(false))
    }


    return (
        <div>
            <Loader isOpen={Loading} />
            <div className='topTitleBar' style={{ marginBottom: "-1rem", height: '70vh' }}>

                <div>
                    You have approved {data?.accept_doc_fields.length} out {original?.discrepancy_log_data.details.length} requests
                    <div className={styles.approvedlistContainer}>

                        {
                            original.discrepancy_log_data.details.map(e => {
                                let status = data.selected.includes(e.doc_field_id)
                                return (
                                    <div className={styles.approvedlist}>
                                        <div><b>{e.doc_field_name}</b></div>
                                        <div className={styles.status} style={status ? { background: '#DEF7EC', color: '#03543F' } : null}>{status ? 'approved' : 'rejected'}</div>
                                    </div>
                                )
                            }
                            )
                        }
                    </div>

                    <div className={styles.commentContainer}>
                        <h4>
                            Comment
                        </h4>
                        {data.comment || 'No Comment Added'}
                    </div>
                </div>

                <div className={styles.pdfcontainer}>
                    {preview &&
                        <embed
                            key={preview}
                            id="pdf-viewer"
                            src={preview + "#toolbar=0"}
                            type="application/pdf"
                        />}
                </div>
            </div>
            <div className='topTitleBar' >
                <div className={styles.buttonBase}>
                    <button className='btn' onClick={e => onClose(false)}>Close</button>
                    <button className='btn btn-primary' onClick={() => reIssue()}>Reissue Document</button>
                </div>
            </div>
        </div>
    )
}
